jQuery(document).ready(function($) {
  $('.CategorySummary .CategorySummary__Item:first-child').addClass('active');
  $('.CategorySummary .CategorySummary__Item').click(function(){
    $('.CategorySummary .CategorySummary__Item').removeClass('active');
    $(this).addClass('active');
    var titleCategory = $(this).find('.CategorySummary__LinkLabel').text();
    $('#shopify-section-ingredients-items .c-about-content-indented h2.o-heading').text(titleCategory);
    $('.ingredients-section__items .CategoryItem').removeClass('hide');
  	var dataCategory = $(this).data('category');
    if(dataCategory) {
      $('.ingredients-section__items .CategoryItem:not(.'+ dataCategory +')').addClass('hide');
    }
  });  
  
  $(".morelink").click(function(event){
    event.preventDefault();
    $(this).parents('.CategoryItem__ItemWrapper').toggleClass('active');
    $(this).parents('.CategoryItem__ItemWrapper').find('.CategoryItem__DescriptionMore').slideToggle();
    $(this).parents('.CategoryItem__ItemWrapper').find('.CategoryItem__ShortDescription').slideToggle();
  });
  
  $(".ingredients-section__items .CategoryItem .CategoryItem__ShortDescription").dotdotdot({
    height: 48,
    fallbackToLetter: true,
    watch: true,
  });
  //   function countLines() {    
  //     var heights = $(".ingredients-section__items .CategoryItem").map(function () {
  //       return $(this).find('.CategoryItem__ShortDescription').height();
  //     }).get();
  //     var maxHeight = Math.max.apply(null, heights);    
  //     $(".ingredients-section__items .CategoryItem").each(function () {
  //       $this = $(this).find('.CategoryItem__ShortDescription');
  //       var lineHeight = parseInt($this.css('line-height'));
  //       if($this.height() > lineHeight*2){
  //         $(this).find('.morelink.more').show();
  //       }
  //     });
  //   }
  //   countLines();
  //   $(window).on('resize', function(){
  //     countLines();
  //   });




  //   var localizationFormSubmit(event) {
  //   event.target.form.text();
  //   }

  //   document.querySelectorAll('.shopify-localization-form select').forEach(function(element) {
  //     element.addEventListener('change', localizationFormSubmit);
  //   });
  
  
})